import { Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import * as yup from 'yup';
import StudentUtil from '../../utils/StudentUtil';
import CancelButton from '../button/CancelButton';
import SubmitButton from '../button/SubmitButton';
import TextField from '../formik/TextField';

const EditStudentDialog = ({ student, open, onClose }) => {
  const initialValues = useMemo(
    () => ({
      firstName: student.firstName,
      lastName: student.lastName,
    }),
    [student],
  );

  const validationSchema = yup.object({
    firstName: yup.string().required('Voornaam is verplicht'),
    lastName: yup.string().required('Achternaam is verplicht'),
  });

  const onSubmit = (values, { setSubmitting }) => {
    StudentUtil.updateStudent(student.id, values)
      .then(() => {
        onClose(true);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Leerling bewerken</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ isValid, isSubmitting }) => (
            <Form>
              <Stack spacing={3}>
                <TextField label="Voornaam*" name="firstName" />
                <TextField label="Achternaam*" name="lastName" />
                <Stack direction="row" justifyContent="end" spacing={1}>
                  <CancelButton onClick={() => onClose(false)} />

                  <SubmitButton disabled={!isValid || isSubmitting}>
                    Opslaan
                    {isSubmitting && <CircularProgress size={14} sx={{ ml: 1 }} />}
                  </SubmitButton>
                </Stack>
              </Stack>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditStudentDialog;
